import Vue from 'vue'
import Vuex from 'vuex'
import Request from './Request.store'
import App from './App.store'
import Alarms from './Alarms.store'
import SearchCondition from './SearchCondition.store'
import Socket from './Socket.store'
import LotHistory from './LotHistory.store'
import VuexPersistence from 'vuex-persist'
import LoadingBar from './LoadingBar.store'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  modules: ['searchCondition', 'lotHistory'],
  // TODO: test 해본 후에 storage를 cookie로 바꾸든지 해야 함!!
  storage: window.localStorage
})

export default new Vuex.Store({
  modules: {
    request: Request,
    app: App,
    alarms: Alarms,
    searchCondition: SearchCondition,
    socket: Socket,
    lotHistory: LotHistory,
    loadingBar: LoadingBar
  },
  plugins: [
    // page refresh 될 때 store state 유지할 module 설정
    vuexLocal.plugin
  ]
})
